import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import CardNav from "./animatedComponents/CardNav";

gsap.registerPlugin(ScrollToPlugin);

interface NavProps {
  initialColor?: string;
}

const Navbar: React.FC<NavProps> = ({ initialColor = "[#f5f5f5]" }) => {
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50">
        {/* Mobile Navigation */}
        <CardNav initialColor={initialColor} />
      </header>
    </>
  );
};

export default Navbar;
